import {Aggregation} from "../../stocks/models/aggregation-selector";
import {b} from "@angular/core/src/render3";

export class ExportExcelColumn{
    constructor(
        header?: string,
        field?: string,
        excelCellBlock?: boolean,
        grouping?: boolean,
        aggregations?: Aggregation
    ){
        this.fill('header', header);
        this.fill('field', field);
        this.fill('excelCellBlock', excelCellBlock);
        this.fill('grouping', grouping);
        this.fill('aggregations', aggregations);
    }

    public header: string;
    public field: string;
    public excelCellBlock: boolean;
    public grouping: boolean;
    public aggregations: Aggregation;

    public readonly fill = (param: string, val: any): void => {
        if (val !== null && typeof val !== 'undefined'){
            this[param] = val;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/export-excel-column.ts